import { Component, Mixins, Prop, VModel, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import RichText from '@/_components/richText/richText/richText.vue'
import RichTextViewer from '@/_components/richText/viewer/viewer.vue'

import StringTokenModel from '@/views/Language/models/stringToken'

@Component({
    components: { RichText, RichTextViewer },
})
export default class TokenInput extends Mixins<MixinInterface>() {
    @VModel({ required: true }) stringToken!: StringTokenModel | Record<string, any>
    @Prop() index!: string

    editorId = crypto['randomUUID']()
    edit = false
    val = ''
    description: string | null = null

    loadingSave = false

    async saveToken() {
        this.loadingSave = true
        if (this.stringToken instanceof StringTokenModel) {
            await this.stringToken.patch(
                this.formatVal(this.val),
                this.description ? JSON.stringify(this.description) : null
            )
        } else {
            if (this.stringToken._id == '-1') {
                this.$emit(
                    'saveToken',
                    this.formatVal(this.val),
                    this.description ? JSON.stringify(this.description) : null
                )
            } else {
                this.stringToken.description = this.description
                this.stringToken.value = this.formatVal(this.val)
            }
        }

        this.loadingSave = false
        this.edit = false
    }

    loadingDelete = false
    async deleteToken() {
        this.loadingDelete = true
        if (this.stringToken instanceof StringTokenModel) {
            await this.stringToken.delete()
        }
        this.$emit('deleteToken', this.stringToken, this.index)
        this.loadingDelete = false
    }

    closeToken() {
        if (this.stringToken._id == '-1') {
            this.$emit('deleteToken', this.stringToken, this.index)
        } else {
            this.edit = false
        }
    }

    @Watch('edit')
    init() {
        if (this.edit) {
            this.val = this.stringToken.value
            this.description = this.stringToken.description
            this.editorId = crypto['randomUUID']()
        }
    }

    formatVal(val) {
        if (val) {
            if (!val.startsWith('{')) {
                val = '{' + val
            }
            if (!val.endsWith('}')) {
                val = val + '}'
            }
        }
        return val
    }

    mounted() {
        this.edit = this.stringToken._id == -1 ? true : false
    }
}
